import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAttendanceSessionPDFJobStatusResponse {
  success: boolean;
  job: Job;
}

export interface Job {
  jobId: string;
  sessionId: string;
  locationId: string;
  studioId: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
  totalClasses: number;
  processedClasses: number;
  failedClasses: number;
  downloadUrl: null | string;
  createdAt: string;
  updatedAt: string;
  error?: string;
}

export interface GetAttendanceSessionPDFJobStatusParams {
  jobId: string;
}

export const getAttendanceSessionPDFJobStatusAPI = async (
  params: GetAttendanceSessionPDFJobStatusParams,
) => {
  const response = await baseAPI.get<GetAttendanceSessionPDFJobStatusResponse>(
    `/attendance/session-pdf-status/${params.jobId}`,
  );
  return response.data;
};

export const getAttendanceSessionPDFJobStatusQueryOptions = (
  params: GetAttendanceSessionPDFJobStatusParams,
) =>
  queryOptions({
    queryKey: [KEYS.ATTENDANCE_SESSION_PDF_JOB_STATUS, params.jobId],
    queryFn: () => getAttendanceSessionPDFJobStatusAPI(params),
    enabled: !!params.jobId,
  });

export const useGetAttendanceSessionPDFJobStatus = (
  params: GetAttendanceSessionPDFJobStatusParams,
) => {
  return useQuery(getAttendanceSessionPDFJobStatusQueryOptions(params));
};
